import { put } from 'redux-saga/effects';
import http from 'axios';
import saveAs from 'react-file-download';
import { swalOpen, swalClose } from "../../utils/index";
import i18n from '../../../utils/i18n';

import {
  COST_LIST,
  COST_SEND_APPROVAL,
  COST_PDF_DOWNLOAD,
  COST_PHOTO_DELETE,
  COST_DELETE,
  COST_UPDATE,
  COST_ADD
} from '../../../api/constants'

import {
  addCostPhoto,
  deleteCostPhotoFailure,
  deleteCostPhotoSuccessful,
  fetchCostListSuccessful,
  setCostFilter,
  updateEmployee
} from '../../actions'
import {
  DOWNLOADING_TITLE,
  PDF_DOWNLOADING_MESSAGE,
  PDF_FILE_NAME, SWAL_ERROR_TITLE,
  SWAL_SUCCESS_TITLE,
  SWAL_TYPE_ERROR,
  SWAL_TYPE_SUCCESS,
  UNKNOWN_ERROR_MESSAGE,
  COST_PHOTO_DELETE_SUCCESS,
  PLEASE_WAIT_TITLE,
  INFORMATION_UPDATE_MESSAGE,
  SWAL_TYPE_INFO,
  COST_UPDATE_MESSAGE,
  COST_EMPTY_FIELD_ERROR_MESSAGE,
  COST_ADDING_MESSAGE,
  COST_DATE_ERROR_MESSAGE,
  COST_INVOICE_NO_ERROR_MESSAGE,
  COST_TYPE_ERROR_MESSAGE,
  COST_AMOUNT_ERROR_MESSAGE,
  COST_MONEY_TYPE_ERROR_MESSAGE,
  COST_PAYMENT_TYPE_ERROR_MESSAGE,
  COST_BRAND_ERROR_MESSAGE,
  COST_DEPARTMENT_ERROR_MESSAGE,
  COST_SUPPLIER_NAME_ERROR_MESSAGE,
  COST_CATEGORY_ERROR_MESSAGE,
  COST_LOCATION_ERROR_MESSAGE,
  COST_DESCRIPTION_ERROR_MESSAGE,
  COST_KDV_ERROR_MESSAGE,
  COST_COMPANY_NAME_ERROR_MESSAGE,
  COST_PLACE_NAME_ERROR_MESSAGE,
  COST_GUEST_NAME_ERROR_MESSAGE,
  COST_GUEST_NUMBER_ERROR_MESSAGE,
  COST_STAFF_NAME_ERROR_MESSAGE,
  COST_STAFF_NUMBER_ERROR_MESSAGE,
  COST_OTHER_PARTICIPANT_ERROR_MESSAGE,
  COST_OTHER_PARTICIPANT_NUMBER_ERROR_MESSAGE,
  COST_ACTUAL_EXPENDITURE_ERROR_MESSAGE,
  COST_PHOTO_ERROR_MESSAGE, COST_DOCUMENTATION_TYPE_ERROR_MESSAGE,
  COST_PUBLIC_SERVANT_ERROR_MESSAGE
} from '../../../utils/constants';

export function* fetchCostList({ payload }) {
  try {
    const { month, year, status, token } = payload;
    let body = new URLSearchParams();
    body.append("month", month);
    body.append("year", year);
    body.append("status", status);
    body.append("accessToken", token);
    const response = yield http.post(COST_LIST, body);
    if (!response.data.err) {
      yield put(fetchCostListSuccessful(response.data.data || []));
      yield put(setCostFilter({}))
    }
  } catch (error) {
    console.error("Error happened when try to fetch cost list.Error : ", error)
  }
}


export function* pdfDownload( {payload} ) {
  try {
    const {employeeName, costIds, accessToken, language} = payload
    let body = new URLSearchParams();
    body.append("accessToken", accessToken);
    body.append("costIds", costIds);
    body.append("pdfLanguage",language)
    swalOpen(DOWNLOADING_TITLE, PDF_DOWNLOADING_MESSAGE, null, true);
    const response = yield http.post(COST_PDF_DOWNLOAD, body, { responseType: "arraybuffer" });
    swalClose();
    yield saveAs(response.data, employeeName + i18n.t('PDF_FILE_NAME'));
  } catch (error) {
    swalOpen(SWAL_ERROR_TITLE, UNKNOWN_ERROR_MESSAGE, SWAL_TYPE_ERROR, false);
    console.error("Error happened when try to download PDF.Error : ", error)
  }
}

export function* sendCostApproval( {payload} ) {
  try {
   const  {costId, accessToken, costGroup} = payload
    let body = new URLSearchParams();
    body.append("costId", costId);
    body.append("accessToken", accessToken);
    body.append("costGroup", costGroup);
    const response = yield http.post(COST_SEND_APPROVAL, body);
    if (!response.data.err) {
      swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
      setTimeout(function () {
        window.location.reload()
      }, 1000);
    } else {
      swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
    }
  } catch (error) {
    console.error("Error happened when try to send approval.Error : ", error)
  }
}

export function* deleteCostPhoto({payload}) {
  try {
    const { costPhotoId, accessToken } = payload
    let formData = new FormData();
    formData.append("accessToken", accessToken);
    formData.append("costPhotoId", costPhotoId);
    const response = yield http.post(COST_PHOTO_DELETE, formData);
    if (!response.data.err) {
      yield put(deleteCostPhotoSuccessful(costPhotoId))
      swalOpen(SWAL_SUCCESS_TITLE, COST_PHOTO_DELETE_SUCCESS, SWAL_TYPE_SUCCESS, false);
      setTimeout(function () {
        window.location.reload()
      }, 1000);
    } else {
      swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
    }
  } catch (error) {
    yield put(deleteCostPhotoFailure(error))
    console.error("Error happened when try to delete cost photo.Error : ", error)
  }
}

export function* deleteCost({ payload }) {
  try {
    const { costId, accessToken, cb } = payload;
    var body = new URLSearchParams();
    body.append("costId", costId);
    body.append("accessToken", accessToken)
    const response = yield http.post(COST_DELETE, body);
    if (!response.data.err) {
      swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
      setTimeout(function () {
        window.location.reload()
      }, 1000);
    } else {
      swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
    }
  } catch (error) {
    console.error("Error happened when try to delete cost.Error : ", error)
  }
}

export function* updateCost(payload) {
  try {
    const { costs, accessToken } = payload;
    debugger;
    swalOpen(PLEASE_WAIT_TITLE, INFORMATION_UPDATE_MESSAGE, SWAL_TYPE_INFO, true);
    yield put(updateEmployee(accessToken));
    swalOpen(PLEASE_WAIT_TITLE, COST_UPDATE_MESSAGE, SWAL_TYPE_INFO, false);
    costs.append("accessToken", accessToken)
    const response = yield http.put(COST_UPDATE, costs);
    if (!response.data.err) {
      swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
      setTimeout(function () {
        window.location.reload()
      }, 1000);
    } else {
      swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
    }
  } catch (error) {
    console.error("Error happened when try to update cost.Error : ", error)
  }
}


export function* costFormValidation({ payload }) {
  const { costFormData, token, status, sendToConfirmation, cb, employeeInformation } = payload;
  let isCostFromValid = true;
  let costs = new FormData();
  let costFormFields = {}
  costFormData.forEach((costData, index) => {
    if (costData) {
      let kdvOraniAktif = employeeInformation.kdvOraniAktif === undefined ? false : employeeInformation.kdvOraniAktif;
      let formFieldsAndRequirements = employeeInformation.formFieldsAndRequirements;
      let { status, costId, costAmount, costDate, costDescription, costType, invoiceNo, moneyType, paymentType, supplierName, kdvOrani, costLocation, costDocumentationType,costCategory, costBrand, companyName, placeName, guestName, guestNumber, staffName, staffNumber, otherParticipant, otherParticipantNumber, preApprovedBudget,isPublicServant } = costData.refs;
      costAmount = costAmount.state.maskedValue;
      costDate = costDate.value;
      costDescription = costDescription.value;
      costType = costType.value;
      kdvOrani = kdvOrani && kdvOrani.value;
      invoiceNo = invoiceNo.value;
      moneyType = moneyType.value;
      paymentType = paymentType.value;
      costLocation = costLocation === undefined ? "0" : costLocation.value;
      costDocumentationType=costDocumentationType === undefined ? "0" : costDocumentationType.value;
      costCategory = costCategory === undefined ? "0" : costCategory.value;
      costBrand = costBrand === undefined ? "0" : costBrand.value;
      supplierName =  supplierName.value;
      status = (status ? status.value : 0);
      const formType = costData.formType;
      if(formType){
      preApprovedBudget = formType ==="settlementSumiagro" ? preApprovedBudget.state.maskedValue : null
      companyName = companyName.value
      placeName = placeName.value
      guestName = guestName.value
      isPublicServant = isPublicServant.value
      guestNumber = guestNumber.value
      staffName = staffName.value
      staffNumber = staffNumber.value
      otherParticipant = otherParticipant.value || '-'
      otherParticipantNumber = otherParticipantNumber.value || '0'
      }
      let invoiceNoCheck = formType === 'applicationSumiagro' ? true : invoiceNo;

      let file = costData.costPhotos && costData.costPhotos[0] && costData.costPhotos[0].files[0];

      //For update
      if (status) {
        file = costData.state.costPhotos && costData.state.costPhotos[0] && costData.state.costPhotos[0].files[0];
        let deletedPhotoId =  costData.state.detail.hasOwnProperty('deletedPhotoId') ? costData.state.detail.deletedPhotoId : false;
        costs.append("cost." + index + ".deletedPhotoId", deletedPhotoId)
      }
      costFormFields.costPhoto = file ? file : costData.state && costData.state.hasOwnProperty('detail') ? costData.state.detail.costPhotos[0] : file ;

      if (file) {
        costs.append("cost." + index + ".costPhoto", file)
      }

      if (costId) {
        costId = costId.value;
      }
      else {
        costId = 0
      }

      const costIdKey = "cost." + index + ".costId";
      const costAmountKey = "cost." + index + ".costAmount";
      const costDateKey = "cost." + index + ".costDate";
      const costDescriptionKey = "cost." + index + ".costDescription";
      const costTypeKey = "cost." + index + ".costType";
      const kdvOraniKey = "cost." + index + ".kdvOrani";
      const invoiceNoKey = "cost." + index + ".invoiceNo";
      const moneyTypeKey = "cost." + index + ".moneyType";
      const paymentTypeKey = "cost." + index + ".paymentType";
      const costLocationKey = "cost." + index + ".costLocation";
      const costDocumentationTypeKey= "cost." + index + ".costDocumentationType";
      const costCategoryKey = "cost." + index + ".costCategory";
      const costBrandKey = "cost." + index + ".costBrand";
      const supplierNameKey = "cost." + index + ".supplierName";
      const statusKey = "cost." + index + ".status";

      const preApprovedBudgetKey = "cost." + index + ".preApprovedBudget";
      const companyNameKey = "cost." + index + ".companyName";
      const placeNameKey = "cost." + index + ".placeName";
      const guestNameKey = "cost." + index + ".guestName";
      const isPublicServantKey = "cost." + index + ".isPublicServant";
      const guestNumberKey = "cost." + index + ".guestNumber";
      const staffNameKey = "cost." + index + ".staffName";
      const staffNumberKey = "cost." + index + ".staffNumber";
      const otherParticipantKey = "cost." + index + ".otherParticipant";
      const otherParticipantNumberKey = "cost." + index + ".otherParticipantNumber";
      const formTypeKey = "cost." + index + ".formType";


      supplierName = formType === "applicationSumiagro" || formType === "settlementSumiagro" ?
      (supplierName ?  supplierName : '-' ) : supplierName;

       const findRequiredFieldsWhichLeftEmpty = () => {
        var requiredFields = Object.keys(formFieldsAndRequirements).map(i => {
          if (formFieldsAndRequirements[i]){
            if (costFormFields[i]){

               /* these below cases will add
                 i === "costAmount" && parseFloat(costFormFields[i]) <= 0
                costType != "-1" && costType
                moneyType != "-1" && moneyType
                paymentType != "-1" && paymentType
                costCategory != "-1" && costCategory
                costLocation != "-1" && costLocation
                costBrand != "-1" && costBrand
                */
              return true
            }
             else{
              return {status: false, type: i}
              }
          }
          else return true
        })
        var requiredFieldsWhichLeftEmpty = requiredFields.filter(a => a !== true)
        return requiredFieldsWhichLeftEmpty.length > 0 ?  requiredFieldsWhichLeftEmpty[0] : false
      };
       let emptyField = findRequiredFieldsWhichLeftEmpty();

      if (parseFloat(costAmount) <= 0) {
        let emptyFieldMessage = formType === 'settlementSumiagro' ? COST_ACTUAL_EXPENDITURE_ERROR_MESSAGE : COST_AMOUNT_ERROR_MESSAGE;
        swalOpen(SWAL_ERROR_TITLE, emptyFieldMessage, SWAL_TYPE_ERROR, false, index);
        isCostFromValid = false;
        costs = [];
        return;
      }
      else if(emptyField){
        //swal msg burada olacak ve return edecek
        let emptyFieldMessage =  COST_PHOTO_ERROR_MESSAGE;
        swalOpen(SWAL_ERROR_TITLE, emptyFieldMessage, SWAL_TYPE_ERROR, false, index);
        isCostFromValid = false;
        costs = [];
        return;
      }
      else if (costAmount && costDate && invoiceNoCheck && costDescription &&  (costType != "-1" && costType) && (moneyType != "-1" && moneyType) && (paymentType != "-1" && paymentType) && (costCategory != "-1" && costCategory) && (costLocation != "-1" && costLocation) && (costDocumentationType != "-1" && costDocumentationType) && (costBrand != "-1" && costBrand) && supplierName) {
        if(formType === "applicationSumiagro" || formType === "settlementSumiagro"){
          if (companyName && placeName && guestName && guestNumber && staffName &&  staffNumber && otherParticipant && otherParticipantNumber && isPublicServant !== "-1"){
          costs.append(companyNameKey, companyName)
          costs.append(placeNameKey, placeName)
          costs.append(guestNameKey, guestName)
          costs.append(guestNumberKey, guestNumber)
          costs.append(staffNameKey, staffName)
          costs.append(staffNumberKey, staffNumber)
          costs.append(preApprovedBudgetKey, preApprovedBudget)
          costs.append(otherParticipantKey, otherParticipant)
          costs.append(otherParticipantNumberKey, otherParticipantNumber)
          costs.append(formTypeKey, formType)
          costs.append(isPublicServantKey, isPublicServant)
        }
        else {
              let emptyFieldMessage = '';
              switch (true) {
                case !companyName:
                  emptyFieldMessage =  COST_COMPANY_NAME_ERROR_MESSAGE;
                  break;
                case !placeName:
                  emptyFieldMessage = COST_PLACE_NAME_ERROR_MESSAGE;
                  break;
                case !guestName:
                  emptyFieldMessage = COST_GUEST_NAME_ERROR_MESSAGE;
                  break;
                case !guestNumber:
                  emptyFieldMessage = COST_GUEST_NUMBER_ERROR_MESSAGE;
                  break;
                case isPublicServant === "-1":
                  emptyFieldMessage = COST_PUBLIC_SERVANT_ERROR_MESSAGE;
                  break;
                case !staffName:
                  emptyFieldMessage = COST_STAFF_NAME_ERROR_MESSAGE
                  break;
                case !staffNumber:
                  emptyFieldMessage = COST_STAFF_NUMBER_ERROR_MESSAGE;
                  break;
                case !otherParticipant:
                  emptyFieldMessage = COST_OTHER_PARTICIPANT_ERROR_MESSAGE;
                  break;
                case !otherParticipantNumber:
                  emptyFieldMessage = COST_OTHER_PARTICIPANT_NUMBER_ERROR_MESSAGE;
                  break;
                default:
                  emptyFieldMessage = COST_EMPTY_FIELD_ERROR_MESSAGE;
                break;
              }
              swalOpen(SWAL_ERROR_TITLE, emptyFieldMessage, SWAL_TYPE_ERROR, false, index);
              isCostFromValid = false;
              return;
        }
        }
        if (kdvOraniAktif === 'true' && (kdvOrani && kdvOrani !== '-1')) {
          costs.append(invoiceNoKey, invoiceNo)
          costs.append(costIdKey, costId)
          costs.append(costAmountKey, costAmount)
          costs.append(costDateKey, costDate)
          costs.append(costDescriptionKey, costDescription)
          costs.append(costTypeKey, costType)
          costs.append(kdvOraniKey, kdvOrani)
          costs.append(moneyTypeKey, moneyType)
          costs.append(paymentTypeKey, paymentType)
          costs.append(supplierNameKey, supplierName)


          if (costCategory != "0") {
            costs.append(costCategoryKey, costCategory)
          }
          if (costLocation != "0") {
            costs.append(costLocationKey, costLocation)
          }
          if (costDocumentationType != "0"){
            costs.append(costDocumentationTypeKey,costDocumentationType)
          }
          if (costBrand != "0") {
            costs.append(costBrandKey, costBrand)
          }
          costs.append(statusKey, status)

        } else if (kdvOraniAktif === 'false' || kdvOraniAktif === undefined) {
          costs.append(invoiceNoKey, invoiceNo)
          costs.append(costIdKey, costId)
          costs.append(costAmountKey, costAmount)
          costs.append(costDateKey, costDate)
          costs.append(costDescriptionKey, costDescription)
          costs.append(costTypeKey, costType)
          costs.append(moneyTypeKey, moneyType)
          costs.append(paymentTypeKey, paymentType)
          costs.append(supplierNameKey, supplierName)

          if (costCategory != "0") {
            costs.append(costCategoryKey, costCategory)
          }
          if (costLocation != "0") {
            costs.append(costLocationKey, costLocation)
          }
          if (costDocumentationType != "0"){
            costs.append(costDocumentationTypeKey,costDocumentationType)
          }
          if (costBrand != "0") {
            costs.append(costBrandKey, costBrand)
          }
          costs.append(statusKey, status)

        } else {
          swalOpen(SWAL_ERROR_TITLE, COST_KDV_ERROR_MESSAGE, SWAL_TYPE_ERROR, false, index);
          isCostFromValid = false;
          return;
        }

      } else {
        let emptyFieldMessage = '';
        switch (true) {
          case !costDate:
            emptyFieldMessage =  COST_DATE_ERROR_MESSAGE;
            break;
          case !invoiceNo:
            emptyFieldMessage = COST_INVOICE_NO_ERROR_MESSAGE;
            break;
          case costType == "-1" :
            emptyFieldMessage = COST_TYPE_ERROR_MESSAGE;
            break;
          case !costAmount:
            emptyFieldMessage = COST_AMOUNT_ERROR_MESSAGE;
            break;
          case moneyType == "-1":
            emptyFieldMessage = COST_MONEY_TYPE_ERROR_MESSAGE;
            break;
          case paymentType == "-1" :
            emptyFieldMessage = COST_PAYMENT_TYPE_ERROR_MESSAGE;
            break;
          case costBrand == "-1" :
            if (costDocumentationType.length > 1) {
              emptyFieldMessage = COST_DEPARTMENT_ERROR_MESSAGE;
            } else if (costDocumentationType) {
              emptyFieldMessage = COST_BRAND_ERROR_MESSAGE;
            }
            break;
          case !supplierName:
            emptyFieldMessage = COST_SUPPLIER_NAME_ERROR_MESSAGE;
            break;
          case costCategory == "-1":
            emptyFieldMessage = COST_CATEGORY_ERROR_MESSAGE;
            break;
          case costLocation == "-1" :
            emptyFieldMessage = COST_CATEGORY_ERROR_MESSAGE;
            break;
          case costDocumentationType == "-1":
            emptyFieldMessage = COST_DOCUMENTATION_TYPE_ERROR_MESSAGE;
            break;
          case !costDescription:
            emptyFieldMessage = COST_DESCRIPTION_ERROR_MESSAGE;
            break;
          default:
            emptyFieldMessage = COST_EMPTY_FIELD_ERROR_MESSAGE;
            break;
        }
        swalOpen(SWAL_ERROR_TITLE, emptyFieldMessage, SWAL_TYPE_ERROR, false, index);
        isCostFromValid = false;
        return;
      }
    }
  });
  if (Array.from(costs.values()).length > 0 && isCostFromValid) {
    if (status) {
      yield updateCost({ 'costs': costs, 'accessToken': token });
    } else {
      yield addCost({
        'costs': costs,
        'accessToken': token,
        'sendToConfirmation': sendToConfirmation
      }
      );
    }
  }
}


export function* addCost(payload) {
  try {
    const { costs, accessToken, sendToConfirmation } = payload;
    swalOpen(PLEASE_WAIT_TITLE, INFORMATION_UPDATE_MESSAGE, SWAL_TYPE_INFO, true);
    yield put(updateEmployee(accessToken));
    swalOpen(PLEASE_WAIT_TITLE, COST_ADDING_MESSAGE, SWAL_TYPE_INFO, false);
    costs.append("sendToConfirmation", sendToConfirmation);
    costs.append("accessToken", accessToken)
    const response = yield http.post(COST_ADD, costs);
    if (!response.data.err) {
      const responseData = response.data.data;
      if (responseData) {
        if (responseData.ids) {
          //Set photos
          if (responseData.photoResult) {
            for (let object of responseData.photoResult) {
              if (!object.err) {
                yield put(addCostPhoto({
                  costId: object.costId,
                  lastModified: new Date().getTime(),
                  photoLink: object.data,
                  status: {
                    class: "success",
                    text: "Yüklendi."
                  },
                  update: true
                }))
              } else {
                yield put(addCostPhoto({
                  costId: object.costId,
                  lastModified: new Date().getTime(),
                  photoLink: object.data,
                  status: {
                    class: "error",
                    text: "Dosya yüklenemedi."
                  },
                  update: true
                }))
              }
            }
          }
          swalOpen(SWAL_SUCCESS_TITLE, responseData.msg, SWAL_TYPE_SUCCESS, false);
          // page refresh
          setTimeout(function () {
            window.location.reload()
          }, 1000);
        }
      }
    } else {
      swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
    }
  } catch (error) {
    console.error("Error happened when try to add cost.Error : ", error)
  }
}
